const CallToActionFullwidth = ({ mainText, subText, ctaImage, ctaText, ctaUrl, buttonType, newTab }) => {
  return (
    <div className="section__call-to-action-fullwidth">
      <div className="section__call-to-action-fullwidth__inner">
        <div>
          <p className="section__call-to-action-fullwidth__inner__main-text">{mainText}</p>
          <p className="section__call-to-action-fullwidth__inner__sub-text">{subText ? subText : ""}</p>
          <a target={newTab === "yes" ? "_blank" : "_self"} className={`section__call-to-action-fullwidth__inner__btn ${buttonType}`} href={ctaUrl}>{ctaText}</a>
        </div>
        <img
          className="homepage__tools__next-icon"
          data-src={ctaImage ? ctaImage.sourceUrl : "/images/request-callback.svg"}
          alt="request-callback"
          width="265"
          height="265"
        />
      </div>
    </div>
  );
};

export default CallToActionFullwidth;
